<script setup>
import BrandButton from "@/Components/Brand/BrandButton.vue";

/**
 * Contact page CTA tile (GH-1121, Figma "CTA1"): a coloured card with a
 * condensed heading, a white "Contact Us" mailto button and a circular photo
 * (flat Figma export, 226×216 @1x) bleeding off the right edge. Below sm the
 * photo drops to 60% height in the bottom corner so the copy keeps its width.
 */
defineProps({
    href: {
        type: String,
        required: true,
    },
    // Tailwind background utility for the card, e.g. "bg-[#ffaf03]".
    bgClass: {
        type: String,
        required: true,
    },
    // Path under public/ for the photo composite.
    image: {
        type: String,
        required: true,
    },
});
</script>

<template>
    <div
        class="relative flex min-h-[216px] flex-col items-start justify-between gap-6 overflow-hidden rounded-[4px] px-6 py-8 sm:px-[43px] sm:py-[38px]"
        :class="bgClass"
    >
        <h3
            class="relative z-10 max-w-[60%] font-brand-display text-[25px] font-black italic uppercase leading-[0.95] tracking-[-0.01em] text-white sm:max-w-[232px]"
        >
            <slot />
        </h3>

        <BrandButton
            :href="href"
            variant="whiteOnRed"
            class="relative z-10 px-[18px] py-[11px] text-[14px] uppercase tracking-[-0.01em]"
        >
            Contact Us
        </BrandButton>

        <img
            :src="asset(image)"
            alt=""
            aria-hidden="true"
            loading="lazy"
            class="pointer-events-none absolute bottom-0 right-0 h-[60%] w-auto max-w-none sm:h-full"
        />
    </div>
</template>
